import React, { useRef, useEffect, useState } from 'react';
import { useAutocomplete } from '../hooks/useGoogleMaps';

const CityAutocomplete = ({ value, onChange, placeholder = 'City (e.g., New York)', className }) => {
  const inputRef = useRef(null);
  const [localValue, setLocalValue] = useState(value || '');

  const autocomplete = useAutocomplete(inputRef, {
    types: ['(cities)']
  });

  useEffect(() => {
    if (!autocomplete) return;
    const listener = autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      const city = extractCity(place);
      setLocalValue(city);
      onChange?.(city);
    });
    return () => {
      window.google?.maps?.event?.removeListener?.(listener);
    };
  }, [autocomplete, onChange]);

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const extractCity = (place) => {
    if (!place || !place.address_components) return localValue || '';
    const comp = place.address_components.find(c => c.types.includes('locality'))
      || place.address_components.find(c => c.types.includes('administrative_area_level_2'))
      || place.address_components.find(c => c.types.includes('sublocality'));
    return comp ? comp.long_name : (place.name || localValue || '');
  };

  return (
    <input
      ref={inputRef}
      type="text"
      value={localValue}
      onChange={(e) => { setLocalValue(e.target.value); onChange?.(e.target.value); }}
      placeholder={placeholder}
      className={className}
    />
  );
};

export default CityAutocomplete;


